import classNames from 'classnames'
import { FC } from 'react'
import styles from 'styles/components/template.module.scss'
import text from 'styles/utility/text.module.scss'
import { CustomerList } from 'components/List'
import { Pagination } from 'components/Pagination'
import { Caution, Description, MainHeadline } from 'components/Typography'
import { NavButton } from 'components/Button'
import { Checkbox, DatePicker, SearchForm, SelectBox, TagCheckbox } from 'components/Form'
import { Spacer } from 'components/Utility'
import { FilterLabel } from 'components/Order'
import { FlexRow } from 'components/Flex'
import { useSearchCustomers } from 'hooks/customer'
import { PER_PAGE } from 'constants/storeCustomer'
import { format } from 'date-fns'

const CustomersTemplate: FC = () => {
  const {
    storeCustomers,
    keyword,
    favoriteCondition,
    maxPurchaseCount,
    minPurchaseCount,
    startOfPeriod,
    endOfPeriod,
    handleKeyword,
    handleFavoriteCondition,
    handleMaxPurchaseCount,
    handleMinPurchaseCount,
    handleStartOfPeriod,
    handleEndOfPeriod,
    maxPurchaseCountOptions,
    minPurchaseCountOptions,
    searchCustomers,
    totalCustomerAmount,
  } = useSearchCustomers()

  return (
    <div className={styles.standard}>
      <Spacer size={40} />
      <MainHeadline headline={'お客さまリスト'} />
      <Spacer size={20} />
      <SearchForm
        isFilled={keyword !== ''}
        onChange={handleKeyword}
        onClick={searchCustomers}
        placeholder={'注文者名・電話番号で検索'}
        value={keyword}
      />
      <Spacer size={12} />
      <FilterLabel label={'検索条件：'} />
      <Spacer size={8} />
      <FlexRow justifyContent={'start'} wrap={'wrap'}>
        <TagCheckbox
          hasHashtag={false}
          id={'favorite'}
          isChecked={favoriteCondition === 'favorite'}
          onChange={handleFavoriteCondition}
          type={'outlined'}
          value={'お気に入り'}
        />
        <TagCheckbox
          hasHashtag={false}
          id={'all'}
          isChecked={favoriteCondition === 'all'}
          onChange={handleFavoriteCondition}
          type={'outlined'}
          value={'すべて'}
        />
      </FlexRow>
      <FlexRow justifyContent={'start'}>
        <label className={classNames(text.font_small)}>購入回数</label>
        <Spacer size={16} axis={'horizontal'} />
        <SelectBox
          options={minPurchaseCountOptions}
          select={handleMinPurchaseCount}
          value={minPurchaseCount.toString()}
          size={'xsmall'}
        />
        <Spacer size={16} axis={'horizontal'} />
        <span>〜</span>
        <Spacer size={16} axis={'horizontal'} />
        <SelectBox
          options={maxPurchaseCountOptions}
          select={handleMaxPurchaseCount}
          value={maxPurchaseCount.toString()}
          size={'xsmall'}
        />
      </FlexRow>
      <Spacer size={8} />
      <FlexRow justifyContent={'start'}>
        <label className={classNames(text.font_small)}>最終購入日</label>
        <Spacer size={16} axis={'horizontal'} />
        <DatePicker
          formSize={'xsmall'}
          max={endOfPeriod || format(new Date(), 'yyyy-MM-dd')}
          onChange={handleStartOfPeriod}
          value={startOfPeriod}
        />
        <Spacer size={16} axis={'horizontal'} />
        <span>〜</span>
        <Spacer size={16} axis={'horizontal'} />
        <DatePicker
          formSize={'xsmall'}
          max={format(new Date(), 'yyyy-MM-dd')}
          min={startOfPeriod || undefined}
          onChange={handleEndOfPeriod}
          value={endOfPeriod}
        />
      </FlexRow>
      <Spacer size={20} />
      <Description description={`${storeCustomers.length}件表示されています`} />
      <Spacer size={20} />
      {storeCustomers.length > 0 ? (
        <CustomerList storeCustomers={storeCustomers} />
      ) : (
        <Caution caution={'検索条件にヒットするお客さまが存在しません'} />
      )}
      <Spacer size={40} />
      <Pagination perPage={PER_PAGE} total={totalCustomerAmount} />
      <Spacer size={40} />
      <NavButton label={'トップページに戻る'} iconPath={'/icon/grey/home.svg'} url={'/'} />
      <Spacer size={40} />
    </div>
  )
}
export default CustomersTemplate
